/**
 * 机甲 M80 / M71 / T87（916）：改键页等与 X98 1K 一致隐藏 Mac Base / Mac Fn 切换。
 */

export type BeiyingMechaM80M71EquipmentLike = {
  keyboardType?: string;
};

function normalizeKeyboardType(s: unknown): string {
  return String(s ?? "")
    .trim()
    .toLowerCase();
}

/** 是否为机甲 M80 / M71 / T87 / X75V2（与 `KEYBOARD_LAYOUTS` / equipment `keyboardType` 一致） */
export function isBeiyingMechaM80OrM71Device(
  eq: BeiyingMechaM80M71EquipmentLike | null | undefined
): boolean {
  const kt = normalizeKeyboardType(eq?.keyboardType);
  return (
    kt === "m80" ||
    kt === "m71" ||
    kt === "t87" ||
    kt === "x75v2" ||
    kt === "m75"
  );
}

export function isBeiyingMechaM80Device(
  eq: BeiyingMechaM80M71EquipmentLike | null | undefined
): boolean {
  const kt = normalizeKeyboardType(eq?.keyboardType);
  return kt === "m80";
}

/**
 * 916 SDK 仅单板载机型（M71 / M80 / T87 / X75V2 / M75）。
 */
export function isBeiying916SingleOnboardKeyboard(
  eq: BeiyingMechaM80M71EquipmentLike | null | undefined
): boolean {
  const kt = normalizeKeyboardType(eq?.keyboardType);
  return (
    kt === "m80" ||
    kt === "m71" ||
    kt === "t87" ||
    kt === "x75v2" ||
    kt === "m75"
  );
}
